import { Route, SidebarLink } from "@/types/types";

export const RouteGenerator = (items: SidebarLink[]): Route[] => {
  return items.map(({ path, element }) => ({
    path,
    element,
  }));
};
